import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ee862dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "加密狗版本信息", -1));
import { getModuleConfigById } from '@/api/authModule';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
export default {
  __name: 'info',
  setup(__props) {
    // import { findAllModuleMenuByConfigId, getModuleConfigById } from '@/api/authModule'
    const route = useRoute();
    const {
      id
    } = route.params;
    // loading效果
    const loading = ref(false);
    const dongleUserVersion = ref({});
    // const dongleUserModule = ref({})

    const getData = async () => {
      loading.value = true;
      dongleUserVersion.value = await getModuleConfigById(id);

      // console.log('dongleUserVersion.value:', dongleUserVersion.value)
      // dongleUserModule.value = await findAllModuleMenuByConfigId({ id: id })
      loading.value = false;
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
        shadow: "never",
        class: "container"
      }, {
        default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_descriptions, {
          border: "",
          class: "descriptionsContent"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            span: 3,
            label: "加密狗版本名称"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(dongleUserVersion.value.name), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 3,
            label: "创建时间"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$filters.dateFilter(dongleUserVersion.value.createTime)), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 3,
            label: "功能模块"
          }, {
            default: _withCtx(() => {
              var _dongleUserVersion$va;
              return [_createTextVNode(_toDisplayString((_dongleUserVersion$va = dongleUserVersion.value) === null || _dongleUserVersion$va === void 0 ? void 0 : _dongleUserVersion$va.number), 1)];
            }),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })), [[_directive_loading, loading.value]]);
    };
  }
};